import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisa = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 10,
	viewBox: "0 0 27 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.98022 8.90737L11.3207 1.13525H13.4152L12.1166 8.90737H9.98022Z",
			fill: "#3C58BF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.98022 8.90737L11.6977 1.13525H13.4152L12.1166 8.90737H9.98022Z",
			fill: "#293688"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6995 1.22189C19.2806 1.04918 18.6104 0.876465 17.7726 0.876465C15.6781 0.876465 14.1701 1.95592 14.1701 3.51035C14.1701 4.67617 15.2173 5.28066 16.0551 5.66927C16.8929 6.05788 17.1442 6.31695 17.1442 6.66237C17.1442 7.18051 16.474 7.43959 15.8876 7.43959C15.0498 7.43959 14.589 7.31005 13.8769 7.0078L13.5836 6.87826L13.2904 8.64858C13.7931 8.86447 14.7147 9.08037 15.6781 9.08037C17.8983 9.08037 19.3644 8.00091 19.3644 6.36013C19.3644 5.45338 18.8198 4.76252 17.5631 4.2012C16.8091 3.8126 16.3483 3.59671 16.3483 3.2081C16.3483 2.86267 16.7253 2.51724 17.5631 2.51724C18.2753 2.51724 18.7779 2.64678 19.1549 2.81949L19.3644 2.90585L19.6995 1.22189Z",
			fill: "#3C58BF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6995 1.22189C19.2806 1.04918 18.6104 0.876465 17.7726 0.876465C15.6781 0.876465 14.5471 1.95592 14.5471 3.51035C14.5471 4.67617 15.2173 5.28066 16.0551 5.66927C16.8929 6.05788 17.1442 6.31695 17.1442 6.66237C17.1442 7.18051 16.474 7.43959 15.8876 7.43959C15.0498 7.43959 14.589 7.31005 13.8769 7.0078L13.5836 6.87826L13.2904 8.64858C13.7931 8.86447 14.7147 9.08037 15.6781 9.08037C17.8983 9.08037 19.3644 8.00091 19.3644 6.36013C19.3644 5.45338 18.8198 4.76252 17.5631 4.2012C16.8091 3.8126 16.3483 3.59671 16.3483 3.2081C16.3483 2.86267 16.7253 2.51724 17.5631 2.51724C18.2753 2.51724 18.7779 2.64678 19.1549 2.81949L19.3644 2.90585L19.6995 1.22189Z",
			fill: "#293688"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.3023 1.13525C22.7996 1.13525 22.4226 1.17843 22.2131 1.69657L19.0714 8.90737H21.3334L21.7523 7.61202H24.4333L24.6846 8.90737H26.6953L24.9359 1.13525H23.3023ZM22.3388 6.31667C22.4645 5.92806 23.1766 4.02821 23.1766 4.02821C23.1766 4.02821 23.3441 3.55325 23.4698 3.251L23.5955 3.98503C23.5955 3.98503 24.0144 5.92806 24.0982 6.35985H22.3388V6.31667Z",
			fill: "#3C58BF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.8049 1.13525C23.3022 1.13525 22.9252 1.17843 22.7158 1.69657L19.0714 8.90737H21.3334L21.7523 7.61202H24.4333L24.6846 8.90737H26.6953L24.9359 1.13525H23.8049ZM22.3388 6.31667C22.5063 5.88488 23.1766 4.02821 23.1766 4.02821C23.1766 4.02821 23.3441 3.55325 23.4698 3.251L23.5955 3.98503C23.5955 3.98503 24.0144 5.92806 24.0982 6.35985H22.3388V6.31667Z",
			fill: "#293688"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.12645 6.57553L5.91701 5.45289C5.54 4.15753 4.3252 2.73265 2.98474 2.04179L4.86977 8.95034H7.1318L10.5248 1.17822H8.26282L6.12645 6.57553Z",
			fill: "#3C58BF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.12645 6.57553L5.91701 5.45289C5.54 4.15753 4.3252 2.73265 2.98474 2.04179L4.86977 8.95034H7.1318L10.5248 1.17822H8.68171L6.12645 6.57553Z",
			fill: "#293688"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.304565 1.13525L0.681571 1.22161C3.3625 1.86929 5.20564 3.51007 5.91776 5.4531L5.16375 1.78293C5.03808 1.26479 4.66107 1.13525 4.20029 1.13525H0.304565Z",
			fill: "#FFBC00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.304565 1.13525C2.98549 1.78293 5.20564 3.46689 5.91776 5.40992L5.20564 2.34425C5.07997 1.82611 4.66107 1.52386 4.20029 1.52386L0.304565 1.13525Z",
			fill: "#F7981D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.304565 1.13525C2.98549 1.78293 5.20564 3.46689 5.91776 5.40992L5.41508 3.72596C5.28942 3.20782 5.12186 2.68968 4.53541 2.47379L0.304565 1.13525Z",
			fill: "#ED7C00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.22115 6.31638L6.79691 4.84831L6.12668 6.48909L5.95912 5.40963C5.58211 4.11428 4.36732 2.68939 3.02686 1.99854L4.91188 8.90708H7.17391L8.22115 6.31638Z",
			fill: "#051244"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1166 8.90791L10.3153 7.00806L9.98022 8.90791H12.1166Z",
			fill: "#051244"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9348 6.2312C17.1023 6.40392 17.1861 6.53345 17.1442 6.70617C17.1442 7.22431 16.474 7.48338 15.8876 7.48338C15.0498 7.48338 14.589 7.35384 13.8769 7.05159L13.5836 6.92206L13.2904 8.69237C13.7931 8.90827 14.7146 9.12416 15.6781 9.12416C17.0186 9.12416 18.1077 8.73555 18.736 8.0447L16.9348 6.2312Z",
			fill: "#051244"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3644 8.90735H21.3332L21.7521 7.612H24.433L24.6843 8.90735H26.695L25.9829 5.75533L23.4696 3.25098L23.5952 3.94183C23.5952 3.94183 24.0141 5.88486 24.0979 6.31664H22.3385C22.5061 5.88486 23.1763 4.02819 23.1763 4.02819C23.1763 4.02819 23.3439 3.55323 23.4696 3.25098",
			fill: "#051244"
		})
	]
});
export default SvgVisa;
